import { faLocationDot } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const PinMarker = () => {
  return (
    <FontAwesomeIcon
      icon={faLocationDot}
      fontSize={'1.5rem'}
      style={{ color: 'var(--primary-blue)' }}
    />
  )
}
